import * as storeNS from '@/store/namespace';
import * as NS from './namespace';
import { ActionContext } from 'vuex';
import { HttpService } from '@/services/http-service';
import { IIndicator, ISensorDevice } from '@/model/meta';
import { IIndicatorValue } from '@/model/datamart';
import dateFormat from 'dateformat';

const actions: NS.IViewingActions = {
    resetForm({ commit, state }: ActionContext<NS.IViewingState, storeNS.IState>, payload: any): void {
        commit('SET_FORM_REQUEST_RESET');
    },

    async loadActiveDevices({ commit, state }:  ActionContext<NS.IViewingState, storeNS.IState>, payload: string | undefined) {
        try {
            if (payload !== undefined) {
                const res = await HttpService.get<ISensorDevice[]>('/user/devices/entities/' + payload);
                commit('SET_ACTIVEDEVICES_SUCCESS', res.data );
                return true;
            } else {
                throw new Error('Не найден id пользователя для запроса устройств');
            }
            
        } catch (error) {
            return false;
        }
    },
    async setAvailableIndicators({ commit, state }:  ActionContext<NS.IViewingState, storeNS.IState>, payload: ISensorDevice) {
        commit('CLEAN_ABAILABLEINDICATORS');

        if (payload !== null && payload !== undefined && payload.sensorDeviceId !== undefined ) {
            try {
                if (payload.availableIndicators === undefined || payload.availableIndicators.length === 0) {
                    const res = await HttpService.get<IIndicator[]>('/device/indicators/entities/' + payload.sensorDeviceId);
                    commit('SET_ABAILABLEINDICATORS_SUCCESS', { device: payload, indicators: res.data } );
                } else {
                    commit('SET_ABAILABLEINDICATORS_SUCCESS', { device: payload, indicators: payload.availableIndicators } );
                }
                
            } catch (error) {
                commit('CLEAN_ABAILABLEINDICATORS');
            }
        } else {
            commit('CLEAN_ABAILABLEINDICATORS');
        }
        
    },
    cleanAvailableIndicators({ commit, state }:  ActionContext<NS.IViewingState, storeNS.IState>, payload: any) {
        commit('CLEAN_ABAILABLEINDICATORS');
    },

    async loadValuesGrid({ commit, state }:  ActionContext<NS.IViewingState, storeNS.IState>
                            , payload: {device: ISensorDevice, indicator: IIndicator, begin: Date, end: Date}) {
        commit('SET_LOADING_REQUEST');
        try {
            const url = '/datamart/values/' + payload.device.code + '/' + payload.indicator.code;
            const query = '?begin=' + dateFormat(payload.begin, "yyyy-mm-dd'T'HH:MM:ss") + '&end=' + dateFormat(payload.end, "yyyy-mm-dd'T'HH:MM:ss");

            const res = await HttpService.get<IIndicatorValue[]>(url + query);
            commit('SET_VALUESGRID_SUCCESS', res.data );
        } catch (error) {
            commit('SET_LOADING_FAIL', error);
        }
    },

    async loadValuesGrids({ commit, state }:  ActionContext<NS.IViewingState, storeNS.IState>
        , payload: {device: ISensorDevice, indicators: IIndicator[], begin: Date, end: Date}) {
        commit('SET_LOADING_REQUEST');
        commit('RESET_INDICATORSVALUES');
        try {
            const result = {} as { [key: string]: IIndicatorValue[] };

            for (const indicator of payload.indicators) {
                const url = '/datamart/values/' + payload.device.code + '/' + indicator.code;
                const query = '?begin=' + dateFormat(payload.begin, "yyyy-mm-dd'T'HH:MM:ss") + '&end=' + dateFormat(payload.end, "yyyy-mm-dd'T'HH:MM:ss");

                const res = await HttpService.get<IIndicatorValue[]>(url + query);

                result[indicator.indicatorId] = res.data;
            }
            
            commit('SET_VALUESGRIDS_SUCCESS', result);
        } catch (error) {
            commit('SET_LOADING_FAIL', error);
        }
    },


    async createIndicatorValue({ commit, state }: ActionContext<NS.IViewingState, storeNS.IState>, payload: IIndicatorValue): Promise<boolean> {
        commit('SET_FORM_REQUEST');

        try {
            const res = await HttpService.post('/datamart/values/', payload);
            commit('SET_INSERT_INDICATORVALUE', payload );
            commit('SET_FORM_REQUEST_RESET');
            return true;
        } catch (error) {
            commit('SET_FORM_REQUEST_FAIL', error);
            return false;
        }
    },
    async deleteIndicatorValue({ commit, state }: ActionContext<NS.IViewingState, storeNS.IState>, payload: IIndicatorValue): Promise<boolean> {
        commit('SET_FORM_REQUEST');

        try {
            const res = await HttpService.delete('/datamart/values/' + payload.indicatorValueId);
            commit('SET_DELETE_INDICATORVALUE', payload );
            commit('SET_FORM_REQUEST_RESET');
            return true;
        } catch (error) {
            commit('SET_FORM_REQUEST_FAIL', error);
            return false;
        }
    },
    async updateIndicatorValue({ commit, state }: ActionContext<NS.IViewingState, storeNS.IState>, payload: IIndicatorValue): Promise<boolean> {
        commit('SET_FORM_REQUEST');
        
        try {
            const res = await HttpService.put('/datamart/values/', payload);
            commit('SET_UPDATE_INDICATORVALUE', payload );
            commit('SET_FORM_REQUEST_RESET');
            return true;
        } catch (error) {
            commit('SET_FORM_REQUEST_FAIL', error);
            return false;
        }
    },


    resetGridData({ commit, state }: ActionContext<NS.IViewingState, storeNS.IState>, payload: IIndicatorValue): void {
        commit('RESET_INDICATORVALUES');
        commit('CLEAN_ABAILABLEINDICATORS');
    },

    resetGridsData({ commit, state }: ActionContext<NS.IViewingState, storeNS.IState>, payload: IIndicatorValue): void {
        commit('RESET_INDICATORSVALUES');
        commit('CLEAN_ABAILABLEINDICATORS');
    },

    async excelExport({ commit, state }: ActionContext<NS.IViewingState, storeNS.IState>
        , payload: { device: ISensorDevice, indicators: IIndicator[], begin: Date, end: Date }): Promise<Blob | null> {
        
        try {
            // нужно составить строку запроса
            // код устройства
            const devicePart = `deviceCode=${payload.device.code}`;
            // массив кодов индикаторов
            const indicatorPart = payload.indicators.map(item => {
                return '&indicatorCodes=' + item.code;
            }).join('');
            // даты
            const periodPart = '&begin=' + dateFormat(payload.begin, "yyyy-mm-dd'T'HH:MM:ss") + '&end=' + dateFormat(payload.end, "yyyy-mm-dd'T'HH:MM:ss");
            const templateResponse = await HttpService({
                url:
                    `/excel/export?${devicePart}${indicatorPart}${periodPart}`,
                method: 'get',
                responseType: 'blob'
            });

            return templateResponse.data;
        } catch (error) {
            console.log(error.message)
            return null;
        }
    },

    
    async uploadExcel({ commit, state }: ActionContext<NS.IViewingState, storeNS.IState>, payload: FormData): Promise<boolean> {
        try {
            commit('SET_UPLOAD_REQUEST');
            await HttpService.post('/excel/uploadtemplate', payload, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            commit('SET_UPLOAD_REQUEST_SUCCES');
            return true;    
        } catch (error) {
            commit('SET_UPLOAD_REQUEST_FAIL');
            return false;
        }
    },

    /** Очистить состояние формы загрузки файла шаблона */
    resetUploadForm({ commit, state }: ActionContext<NS.IViewingState, storeNS.IState>, payload: any): void {
        commit('SET_UPLOAD_REQUEST_RESET');
    }
};

/** Реализация действий модуля просмотра */
export default actions;